import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 27px;
  text-align: left;
  margin-bottom: 16px;
`;
